/* eslint-disable no-param-reassign */
import ApiManager from '../api/manager';

class KvkCheck {
  constructor(options = {}) {
    this.config = {
      module: document.querySelector('.js-kvk-check'),
      registerFormInput: (module, inputName) => module.querySelector(`[name="${inputName}"]`),
      microServiceSettings: {
        company: 'aircovent',
        url: 'https://microservice-kvk-live.pangaea19.nl/api/v1/kvk/company',
        testUrl: 'https://microservice-kvk.pangaeatest.nl/api/v1/kvk/testcompany'
      },
      ...options
    };
    this.apiManager = new ApiManager();
  }

  async hasCompanyAccount(kvkNumber) {
    const api = this.apiManager;
    const url = `/api/v1/aircovent/verifycoc?cocNumber=${kvkNumber}`;
    return api
      .get(url)
      .then(data => data)
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('getCompanyAccount from request failed', error);
        return null;
      });
  }

  async getCompany(kvkNumber) {
    const api = this.apiManager;
    const { microServiceSettings } = this.config;

    if (!microServiceSettings) return null;

    const { url, company } = microServiceSettings;
    const apiUrl = `${url}/${company}/${kvkNumber}`;

    return api
      .get(apiUrl)
      .then(data => data)
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('getCompany from request failed', error);
        return null;
      });
  }

  autofillForm(addressObject) {
    const { module } = this.config;

    const inputs = module.querySelectorAll('[data-field]');
    inputs.forEach(input => {
      const { field } = input.dataset;
      const ignoreFields = ['kvkNumber', 'sbImatched'];

      if (!ignoreFields.includes(field)) {
        const value = addressObject[field];

        input.value = value;

        if (value && value.length) {
          input.setAttribute('readonly', true);
        }
      }
    });
  }

  enableAccountRegister(enabled) {
    const { module } = this.config;

    const submitButton = module.querySelector('[data-submit]');
    if (!submitButton) return;
    submitButton.disabled = !enabled;
    if (!enabled) return;
    const hiddenFields = module.querySelectorAll('.form-group.hidden');
    hiddenFields.forEach(field => field.classList.remove('hidden'));
  }

  displayAlert(type, datasetName) {
    const { module } = this.config;

    const alertModule = module.querySelector('[data-module="alert"]');
    if (!alertModule) return;
    alertModule.className = '';
    alertModule.classList.add('alert', `alert-${type}`);
    alertModule.innerHTML = alertModule.dataset[datasetName];
  }

  async verifyKvkNumber(kvkNumber) {
    const { module } = this.config;

    const kvkInputField = module.querySelector('[data-field="kvkNumber"]');
    let kvkAccountExists = false;

    // add loading
    kvkInputField.setAttribute('readonly', true);
    module.classList.add('is-loading');

    // function to remove disable from all form inputs
    const resetDisabledInputs = () => {
      const inputs = module.querySelectorAll('[data-field]');
      inputs.forEach(input => {
        input.removeAttribute('readonly');
      });
    };

    // check if account with kvk already exists
    await this.hasCompanyAccount(kvkNumber).then(result => {
      kvkInputField.removeAttribute('readonly');
      module.classList.remove('is-loading');
      kvkAccountExists = result;

      if (!kvkAccountExists) {
        return;
      }

      this.displayAlert('danger', 'accountExists');
      this.enableAccountRegister(false);
    });

    if (kvkAccountExists) return;

    // api class
    await this.getCompany(kvkNumber).then(result => {
      // remove loading
      kvkInputField.removeAttribute('readonly');
      module.classList.remove('is-loading');

      // check if object has data
      if (result && Object.keys(result).length > 0) {
        this.autofillForm(result);

        if (
          result.sbImatched.toLowerCase() === 'sbi_ok' ||
          result.sbImatched.toLowerCase() === 'sbi_not_ok'
        ) {
          this.displayAlert('success', 'registerAccount');
          this.enableAccountRegister(true);
        } else {
          this.displayAlert('info', 'noData');
          this.enableAccountRegister(false);
          resetDisabledInputs();
        }
      } else {
        this.displayAlert('warning', 'error');
        this.enableAccountRegister(false);
        resetDisabledInputs();
      }
    });
  }

  init() {
    const { module } = this.config;
    if (!module) return;

    const handleBlur = event => {
      const { target } = event;

      if (!target.value) return;

      const { maxLength, value } = target;

      // validation
      if (Number.isNaN(Number(value)) || (maxLength && value.length !== maxLength)) {
        this.displayAlert('danger', 'invalidError');
      }
    };

    const handleInput = event => {
      const { target } = event;

      if (!target.value) return;

      const { maxLength, value } = target;

      // trigger api
      if (!Number.isNaN(Number(value)) && (!maxLength || value.length === maxLength)) {
        this.verifyKvkNumber(value);
      }
    };

    const bindEvents = input => {
      input.addEventListener('input', handleInput);
      input.addEventListener('blur', handleBlur);
    };

    const kvkInputField = module.querySelector('[data-field="kvkNumber"]');
    if (!kvkInputField) return;
    bindEvents(kvkInputField);
  }
}

export default KvkCheck;
